// extracted by mini-css-extract-plugin
export default {"root":"IconChecklist_root__OYyQz"};